import InlineMessage from "./inlineMessage/InlineMessage";
import { useTranslation } from "../state/i18n";
import type { VoidComponent } from "solid-js";
import { isNil } from "lodash-es";
import { LEGACY_PLATFORM_BASE_URL } from "../constants";

type UnderConstructionProps = {
  oldPlatformPath?: string;
};

const UnderConstruction: VoidComponent<UnderConstructionProps> = (props) => {
  const { t } = useTranslation();

  return (
    <InlineMessage
      variant="warning"
      label={t(($) => $.UNDER_CONSTRUCTION_MESSAGE)}
      action={
        !isNil(props.oldPlatformPath)
          ? {
              label: t(($) => $.UNDER_CONSTRUCTION_OLD_PLATFORM_ACTION),
              onClick: () => (window.location.href = LEGACY_PLATFORM_BASE_URL + props.oldPlatformPath),
            }
          : undefined
      }
    />
  );
};

export default UnderConstruction;
